"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectangleCanvasDrawer = exports.RectangleCanvasDrawStep = exports.RectangleSVGDrawer = void 0;
var tslib_1 = require("tslib");
var canvasDrawer_1 = require("./canvasDrawer");
var svgDrawer_1 = require("./svgDrawer");
var RectangleSVGDrawer = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RectangleSVGDrawer, _super);
    function RectangleSVGDrawer(_rootClassName) {
        if (_rootClassName === void 0) { _rootClassName = ""; }
        var _this = _super.call(this, "rect", "") || this;
        _this._rootClassName = _rootClassName;
        _this._root.classed(_this._rootClassName, true);
        return _this;
    }
    return RectangleSVGDrawer;
}(svgDrawer_1.SVGDrawer));
exports.RectangleSVGDrawer = RectangleSVGDrawer;
var RECT_ATTRS = canvasDrawer_1.ContextStyleAttrs.concat(["x", "y", "width", "height"]);
var RectangleCanvasDrawStep = function (context, data, projector) {
    context.save();
    var dataLen = data.length;
    for (var index = 0; index < dataLen; index++) {
        var datum = data[index];
        if (datum == null) {
            continue;
        }
        var attrs = (0, canvasDrawer_1.resolveAttributes)(projector, RECT_ATTRS, datum, index);
        context.beginPath();
        context.rect(attrs["x"], attrs["y"], attrs["width"], attrs["height"]);
        (0, canvasDrawer_1.renderPathWithStyle)(context, attrs);
    }
    context.restore();
};
exports.RectangleCanvasDrawStep = RectangleCanvasDrawStep;
var RectangleCanvasDrawer = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RectangleCanvasDrawer, _super);
    function RectangleCanvasDrawer(ctx) {
        return _super.call(this, ctx, exports.RectangleCanvasDrawStep) || this;
    }
    return RectangleCanvasDrawer;
}(canvasDrawer_1.CanvasDrawer));
exports.RectangleCanvasDrawer = RectangleCanvasDrawer;
